// WebSocket Event Bus - Single source of truth for WebSocket events
class WebSocketEventBus {
  constructor() {
    this.listeners = new Map();
  }

  // Subscribe to WebSocket events
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
    console.log(`🚌 EventBus: Registered listener for ${event}`);
  }

  // Unsubscribe from WebSocket events
  off(event, callback) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback);
      console.log(`🚌 EventBus: Removed listener for ${event}`);
    }
  }

  // Emit events to all subscribers
  emit(event, data) {
    console.log(`🚌 EventBus: Emitting ${event} to ${this.listeners.get(event)?.size || 0} listeners`);
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`🚌 EventBus: Error in ${event} listener:`, error);
        }
      });
    }
  }

  // Get listener count for debugging
  getListenerCount(event) {
    return this.listeners.get(event)?.size || 0;
  }

  // Get all events for debugging
  getAllEvents() {
    return Array.from(this.listeners.keys());
  }
}

// Create singleton instance
const webSocketEventBus = new WebSocketEventBus();

export default webSocketEventBus;